//操作员接口
import operatorApi from "@api/operator";
//业务接口
import macApi from "@api/mac"
import oemApi from "@api/oem"
import deviceAuthApi from "@api/deviceAuth"
import platformAuthApi from "@api/platformAuth"
import appApi from "@api/app"
import logApi from "@api/log"
import permissionApi from "@api/permission"

export default {
  ...operatorApi,
  ...macApi,
  ...oemApi,
  ...deviceAuthApi,
  ...platformAuthApi,
  ...appApi,
  ...logApi,
  ...permissionApi,
};
